module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "actions-container"
  }, [_c('button', {
    staticClass: "btn btn-primary margin-left-10",
    on: {
      "click": _vm.onBrowseFileClick
    }
  }, [_vm._v("\n            Upload PDF file\n            "), _c('i', {
    staticClass: "icon-attachments"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success margin-left-10",
    attrs: {
      "disabled": _vm.file == null
    },
    on: {
      "click": _vm.runAnalysis
    }
  }, [_vm._v("\n            Run analysis\n            "), _c('i', {
    staticClass: "icon-lifecycle"
  })])]), _vm._v(" "), (_vm.file != null) ? _c('web-viewer', {
    ref: "webViewerComponent",
    attrs: {
      "file": _vm.file
    }
  }) : _vm._e(), _vm._v(" "), (_vm.file == null) ? _c('div', {
    staticClass: "upload-file-message text-center"
  }, [_c('i', {
    staticClass: "icon-contracts font-size-100"
  }), _vm._v(" "), _c('h2', [_vm._v("No file uploaded.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg margin-left-10",
    on: {
      "click": _vm.onBrowseFileClick
    }
  }, [_vm._v("\n            Upload PDF file\n            "), _c('i', {
    staticClass: "icon-attachments"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "import-container"
  }, [_c('input', {
    ref: "browseFile",
    attrs: {
      "type": "file",
      "accept": "application/pdf",
      "id": "file-import"
    },
    on: {
      "change": function($event) {
        return _vm.chooseFile($event)
      }
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('b', [_vm._v("Upload contract and run analysis!")])])
}]}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-645cdddc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-645cdddc!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Scripts/modules/view-contract/ViewContract.vue
// module id = 36
// module chunks = 1